export default __webpack_public_path__ + "static/media/yellowActiveSvg.eef6d21a.svg";